// extracted by mini-css-extract-plugin
export default {"section_card":"SkeletonCardsGrid_section_card__CQ3Fa","skeleton":"SkeletonCardsGrid_skeleton__vc2B5"};